import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function Perfil() {
  const { user, setUser, logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ ...(user || {}) });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    setLoading(true);
    try {
      const { data } = await api.put("/auth/me", {
        full_name: form.full_name, phone: form.phone, cargo: form.cargo, orgao: form.orgao,
        cidade: form.cidade, estado: form.estado, profile: form.profile,
      });
      setUser(data);
      localStorage.setItem("ceap_user", JSON.stringify(data));
      toast.success("Perfil atualizado");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erro ao salvar");
    } finally { setLoading(false); }
  };

  if (!user) return null;
  return (
    <div className="space-y-4" data-testid="perfil-page">
      <h1 className="font-display font-semibold text-xl text-[hsl(var(--primary))]">Meu perfil</h1>
      <Card className="rounded-2xl">
        <CardContent className="p-5 space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-14 h-14 rounded-full bg-[hsl(var(--primary))] text-white flex items-center justify-center font-display font-semibold text-lg">
              {(user.full_name || "").split(" ").map(s => s[0]).slice(0,2).join("")}
            </div>
            <div>
              <p className="font-display font-semibold text-[hsl(var(--primary))]">{user.full_name}</p>
              <p className="text-xs text-muted-foreground font-mono-id">{user.ceap_id}</p>
              <Badge className="mt-1 bg-[hsl(var(--gold)/0.18)] text-[hsl(var(--gold-foreground))] border-[hsl(var(--gold)/0.35)]">{user.level}</Badge>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-3">
            <div><Label>Nome completo</Label><Input value={form.full_name || ""} onChange={set("full_name")} data-testid="profile-name-input" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label>CPF</Label><Input value={form.cpf || ""} disabled /></div>
              <div><Label>Telefone</Label><Input value={form.phone || ""} onChange={set("phone")} /></div>
            </div>
            <div><Label>E-mail</Label><Input value={form.email || ""} disabled /></div>
            <div><Label>Cargo</Label><Input value={form.cargo || ""} onChange={set("cargo")} /></div>
            <div><Label>Órgão</Label><Input value={form.orgao || ""} onChange={set("orgao")} /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label>Cidade</Label><Input value={form.cidade || ""} onChange={set("cidade")} /></div>
              <div><Label>Estado</Label><Input maxLength={2} value={form.estado || ""} onChange={(e) => setForm(f => ({ ...f, estado: e.target.value.toUpperCase() }))} /></div>
            </div>
            <div><Label>Área de interesse</Label>
              <Select value={form.profile} onValueChange={(v) => setForm(f => ({ ...f, profile: v }))}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="legislativo">Legislativo</SelectItem>
                  <SelectItem value="licitacoes">Licitações</SelectItem>
                  <SelectItem value="ambos">Ambos</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <Button onClick={save} disabled={loading} className="w-full h-11" data-testid="profile-save-button">
            {loading ? "Salvando…" : "Salvar alterações"}
          </Button>
        </CardContent>
      </Card>
      <Card className="rounded-2xl">
        <CardContent className="p-5">
          <p className="text-sm font-medium">Estatísticas</p>
          <div className="grid grid-cols-3 gap-2 mt-2">
            <div className="text-center"><p className="font-display text-2xl font-semibold text-[hsl(var(--primary))]">{user.courses_completed}</p><p className="text-[11px] text-muted-foreground">Cursos</p></div>
            <div className="text-center"><p className="font-display text-2xl font-semibold text-[hsl(var(--primary))]">{user.hours_accumulated}h</p><p className="text-[11px] text-muted-foreground">Horas</p></div>
            <div className="text-center"><p className="font-display text-2xl font-semibold text-[hsl(var(--primary))]">{user.is_validated ? "✓" : "—"}</p><p className="text-[11px] text-muted-foreground">Validado</p></div>
          </div>
        </CardContent>
      </Card>
      <Button variant="outline" className="w-full" onClick={() => { logout(); navigate("/login"); }} data-testid="profile-logout">Sair da conta</Button>
    </div>
  );
}
